var apibaseurl =
  "https://2ui309ejdk.execute-api.ap-south-1.amazonaws.com/Prod/api/";
import axios from "axios";
var header = {
  headers: {
    "Content-Type": "application/json",
  },
};
export default {

  profile(data) {
    return axios.post(apibaseurl + "Customers/societyprofile",JSON.stringify(data),header);
  },

  UpdateCustomersProfile(data) {//Customers/profile/
    return axios.post(apibaseurl + "Customers/Updatesocietyprofile",JSON.stringify(data),header);
  },

  mappsocietyfarmer(data) {//Customers/mappsocietyfarmer
    return axios.post(apibaseurl + "Customers/mappsocietyfarmer",JSON.stringify(data),header);
  },

  statesList(data) {//Dropdown/statesList
    return axios.post(apibaseurl + "Dropdown/statesList",JSON.stringify(data),header);
  },

  citieslist(data) {//Dropdown/citieslist
    return axios.post(apibaseurl + "Dropdown/citieslist",JSON.stringify(data),header);
  },

  sendotp(data) {//Auth/sendotp
    return axios.post(apibaseurl + "Auth/sendotpsociety",JSON.stringify(data),header);
  },

  verifyotp(data) {
    return axios.post(apibaseurl + "Auth/verifyotpsociety",JSON.stringify(data),header);
  },

  Getsocietyfarmerslist(data) {
    return axios.post(apibaseurl + "Customers/Getsocietyfarmerslist",JSON.stringify(data),header);
  },

  farmersocietiesorderlistgroupbyfarmer(data) {
    return axios.post(apibaseurl + "Society/farmersocietiesorderlistgroupbyfarmer",JSON.stringify(data),header);
  },

  addCustomerSocietyOrder(data) {
    return axios.post(apibaseurl + "Society/addCustomerSocietyOrder",JSON.stringify(data),header);
  },

  farmersocietiesorderlistgroup(data) {
    return axios.post(apibaseurl + "Society/farmersocietiesorderlistgroup",JSON.stringify(data),header);
  },

  generatebill(data) {//Society/generatebill
    return axios.post(apibaseurl + "Society/generatebill",JSON.stringify(data),header);
  },
  getBillList(data) {
    return axios.post(apibaseurl + "Society/getBillList",JSON.stringify(data),header);
  },
  getBillDetails(data) {
    return axios.post(apibaseurl + "Society/getBillDetails",JSON.stringify(data),header);
  },
  addsnf(data) {
    return axios.post(apibaseurl + "Society/addsnf",JSON.stringify(data),header);
  },
  ratelist(data) {
    return axios.post(apibaseurl + "Society/ratelist",JSON.stringify(data),header);
  },

  getdashboarddata(data) {
    return axios.post(apibaseurl + "Society/getdashboarddata",JSON.stringify(data),header);
  },



};
